module.exports = __webpack_public_path__ + "media/images/spectrumone-31f8be1c7b41ee217db91dc1f769c561.png";